import { ApiStateBase } from 'services/api/types';
import useAuth from '../auth/auth';

interface DevToolsProps {
  deleteAllStatus: ApiStateBase<string>;
  onDeleteAll: () => void;
}

const DevTools: React.FC<DevToolsProps> = ({
  deleteAllStatus,
  onDeleteAll,
}) => {
  const { isViewer, userId, roles } = useAuth();
  const buildId = process.env.REACT_APP_ENV ?? 'Not Set';

  return (
    <div style={styles.containerStyle}>
      <p>
        <strong>User_ID:</strong> {userId}
      </p>
      <p>
        <strong>Build:</strong> {buildId}
      </p>
      <p>
        <strong>Roles:</strong>{' '}
        {roles.length > 0 ? roles.join(', ') : 'No roles assigned'}
      </p>
      <button
        onClick={onDeleteAll}
        disabled={isViewer || deleteAllStatus.status === 'loading'}
        style={
          isViewer || deleteAllStatus.status === 'loading'
            ? styles.buttonDisabled
            : styles.buttonEnabled
        }>
        {deleteAllStatus.status === 'loading'
          ? 'Deleting...'
          : 'Delete All Products'}
      </button>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  containerStyle: {
    backgroundColor: '#f9fafb', // bg-gray-50
    borderBottom: '1px solid #e5e7eb', // border-b
    paddingLeft: '3rem', // px-12
    paddingRight: '3rem',
    paddingTop: '0.75rem', // py-3
    paddingBottom: '0.75rem',
    fontSize: '0.75rem', // text-xs
    color: '#4b5563', // text-gray-600
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem', // space-y-2
  } as React.CSSProperties,
  buttonEnabled: {
    padding: '0.5rem 1rem', // px-4 py-2
    borderRadius: '0.25rem', // rounded
    backgroundColor: '#dc2626', // bg-red-600
    color: 'white',
    border: 'none',
    cursor: 'pointer',
    alignSelf: 'flex-start', // Prevent full-width stretching
  } as React.CSSProperties,
  buttonDisabled: {
    padding: '0.5rem 1rem', // px-4 py-2
    borderRadius: '0.25rem', // rounded
    backgroundColor: '#d1d5db', // bg-gray-300
    color: '#6b7280', // text-gray-500
    cursor: 'not-allowed',
    border: 'none',
    alignSelf: 'flex-start', // Prevent full-width stretching
  } as React.CSSProperties,
};

export default DevTools;
